export const getSocialServiceOperationFrag = `
    id
    name
    description
    type
    billCode
    mpsvBasic
    mpsvMeeting
    noRecord
    facultativeCode
    informationCode
    unit
    payment
    maxPrice
    maxPriceExt
    validFrom
    validTo
`;

export const getSocialServiceOperationProcedureFrag = `
    id
    socialServiceOperationId
    code
    name
    description
    unit
    winCarolCode
    customCode
    payment
    maxPrice
    maxPriceExt
    validFrom
    validTo
`;
